// Colour mode toggle: flips html[data-theme], remembers the visitor's choice, and follows the
// system setting until they pick one. The icon swap itself is CSS (nutravey-dark.css).
(function () {
  var root = document.documentElement;
  var storageKey = 'nutravey-theme';

  var sync = function () {
    var dark = root.dataset.theme === 'dark';
    document.querySelectorAll('[data-nv-theme-toggle]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(dark));
      button.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
    });
  };

  var apply = function (theme, remember) {
    root.classList.add('nv-theme-switching');
    root.dataset.theme = theme;
    var chrome = document.querySelector('meta[data-nv-theme-color]');
    if (chrome) chrome.content = theme === 'dark' ? '#1a0710' : '#fcf9f6';
    if (remember) {
      try {
        localStorage.setItem(storageKey, theme);
      } catch (error) {}
    }
    sync();
    setTimeout(function () {
      root.classList.remove('nv-theme-switching');
    }, 450);
  };

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-nv-theme-toggle]')) return;
    apply(root.dataset.theme === 'dark' ? 'light' : 'dark', true);
  });

  var system = window.matchMedia('(prefers-color-scheme: dark)');
  var followSystem = function (event) {
    var saved = null;
    try {
      saved = localStorage.getItem(storageKey);
    } catch (error) {}
    if (saved !== 'light' && saved !== 'dark') apply(event.matches ? 'dark' : 'light', false);
  };
  if (system.addEventListener) system.addEventListener('change', followSystem);
  document.addEventListener('shopify:section:load', sync);
  sync();
})();

(function () {
  var header = document.querySelector('.section-header');
  if (!header) return;

  var isIndex = document.body.querySelector('main[data-template="index"]');
  if (!isIndex) return;

  header.classList.add('nv-header-transparent');

  var hero = document.querySelector('#MainContent > .shopify-section:first-child');
  if (!hero) return;

  // Transparent only while the hero is still behind the header bar itself; once the
  // section below slides under it, the light menu would vanish on the cream background.
  var frame = null;
  var update = function () {
    frame = null;
    var overHero = hero.getBoundingClientRect().bottom > header.offsetHeight;
    header.classList.toggle('nv-header-transparent', overHero);
    header.classList.toggle('nv-header-solid', !overHero);
  };
  var request = function () {
    if (!frame) frame = requestAnimationFrame(update);
  };

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  update();
})();
